var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEolic2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 232,
    viewBox: "0 0 83 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "large_fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base_shade",
    d: "M49.8204 44.3613H47.393L44.9023 231.246H49.8204H54.7384L52.2266 44.3613H49.8204Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "base",
    d: "M47.284 44.4043H46.2743L45.2383 231.245H47.284H49.3297L48.2849 44.4043H47.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.9523 41.6016H45.6055C44.2758 41.6016 43.1953 43.0559 43.1953 44.8635C43.1953 46.6711 44.2758 48.1255 45.6055 48.1255H55.9523C57.282 48.1255 58.3624 46.6711 58.3624 44.8635C58.3624 43.0559 57.282 41.6016 55.9523 41.6016Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.5861 44.1113C44.0874 44.1113 43.6719 44.6723 43.6719 45.3579C43.6719 46.0436 44.0874 46.6045 44.5861 46.6045C45.0847 46.6045 45.5002 46.0436 45.5002 45.3579C45.5002 44.6723 45.0847 44.1113 44.5861 44.1113Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1686552861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M44.5819 42.0742C43.2522 42.0742 42.1719 43.5286 42.1719 45.3362C42.1719 47.1437 43.2522 48.5981 44.5819 48.5981C45.9116 48.5981 46.992 47.1437 46.992 45.3362C46.992 43.5286 45.9116 42.0742 44.5819 42.0742Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fan_center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M44.195 48.6844C44.2365 50.2219 44.6936 51.6971 45.5455 52.9852L65.1172 82.8206C65.4911 83.4024 66.4053 82.9453 66.156 82.3012L54.895 51.4686C54.521 50.4297 53.8146 49.5362 52.9212 48.9129C52.9212 48.9129 46.522 43.9474 46.1895 43.8227L44.0703 44.1759L44.195 48.6844Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M44.195 48.6844C44.2365 50.2219 44.6936 51.6971 45.5455 52.9852L65.1172 82.8206C65.4912 83.4024 66.4053 82.9453 66.156 82.3012L51.1104 55.13C51.1104 55.13 46.522 43.9474 46.1895 43.8227L44.0703 44.1759L44.195 48.6844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.1032 30.7737C46.3968 31.6256 45.9604 32.6644 45.8773 33.7656C45.8773 33.7656 44.7762 41.7855 44.8385 42.1387L46.2098 43.8008L50.0742 41.4322C51.3832 40.6219 52.4428 39.4792 53.1284 38.108L69.1681 6.23638C69.4797 5.61308 68.6486 5.07289 68.1916 5.59231L47.1239 30.7529L47.1032 30.7737Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0.855051 41.0602C0.169419 41.1018 0.107075 42.099 0.792708 42.2237L33.1213 47.8957C34.2017 48.0827 35.3237 47.9373 36.321 47.4595C36.321 47.4595 43.8213 44.4053 44.0914 44.1767L44.8394 42.1613L40.8711 40.0006C39.5206 39.2734 38.0039 38.9202 36.4664 39.0241L0.855051 41.0602Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.0629 47.5432C35.7795 48.0774 34.3876 48.2328 32.9979 47.9811L0.872017 42.2848C0.248546 42.1803 0.273537 41.2284 0.900415 41.2031L29.0883 44.0124C29.0883 44.0124 41.6897 43.2989 41.9204 43.5373L41.9204 45.242L37.0629 47.5432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.3112 41.6807C51.6219 40.8759 52.6709 39.7425 53.3606 38.3607L69.1941 6.37413C69.5109 5.75938 68.9456 5.49517 68.5125 6.03313L52.4356 32.4689C52.4356 32.4689 45.0453 42.0339 45.1036 42.3841L46.4691 44.0429L50.3112 41.6807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.9648 44.462L41.9648 45.0852C41.9648 45.8955 43.1907 49.3652 44.5204 49.3652C45.7462 49.3652 47.0759 45.7916 47.0759 45.0852L47.0759 44.462C47.0759 43.527 45.9332 42.7582 44.5204 42.7582C43.1076 42.7582 41.9648 43.527 41.9648 44.462Z",
    fill: "#EBEFF2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEolic2);
export default __webpack_public_path__ + "static/media/eolic2.1c9707dc34a18e7dfc81eae1b88e3b12.svg";
export { ForwardRef as ReactComponent };